export default __webpack_public_path__ + "static/media/correspondent1.cd94695f.png";